import { useCallback, useContext } from "react";
import AppContext from "../context/AppContext";
import { getCallCenterT } from "../components/common/CallCenterTranslations";

/** Returns a translator function `t(key)` for Call Center UI strings. */
export function useCallCenterT() {
  const { langMode } = useContext(AppContext);
  return useCallback(getCallCenterT(langMode), [langMode]);
}

export default useCallCenterT;
